/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback } from 'react';

import { Textarea } from 'components/rfs-ui';
import { isFunction } from 'utils/lodash';
import { PTInput } from '../propTypes';

const TextareaComponent = ({ input, meta, onChange, ...props }) => {
  const handleChange = useCallback(
    (value) => {
      input.onChange(value);
      if (isFunction(onChange)) {
        onChange(value);
      }
    },
    [onChange, input],
  );

  return <Textarea {...props} onChange={handleChange} value={input.value} />;
};

TextareaComponent.propTypes = {
  ...Textarea.propTypes,
  ...PTInput,
};

export default TextareaComponent;
